import { render, staticRenderFns } from "./WorkoutTypeModal.vue?vue&type=template&id=bbc12bb2&scoped=true"
import script from "./WorkoutTypeModal.vue?vue&type=script&lang=js"
export * from "./WorkoutTypeModal.vue?vue&type=script&lang=js"
import style0 from "./WorkoutTypeModal.vue?vue&type=style&index=0&id=bbc12bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc12bb2",
  null
  
)

export default component.exports